/*
 * BoxCollapse Messages
 *
 * This contains all the text for the BoxCollapse component.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.components.BoxCollapse';

export default defineMessages({
  editItem: {
    id: `${scope}.editItem`,
    defaultMessage: 'Edit item',
  },
});
